module.exports = __webpack_public_path__ + "img/alpps-temp-logo.94be4de5.png";